import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ServiceDefinitionComponent } from './service-definition.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ServiceDefinitionRoutingModule } from './service-definition-routing.module';
import { IconsModule } from 'src/app/icons/icons.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {SearchFilterModule} from '../../components/search-filter/search-filter.module';
import { SearchBoxModule } from 'src/app/components/search-box/search-box.module';
import { PaginatorModule } from 'src/app/components/paginator/paginator.module';
import { TenantSolutionsComponent } from './tenant-solutions/tenant-solutions.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatCardModule } from '@angular/material/card';
import { ChooseCapabilityComponent } from './choose-capability/choose-capability.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { ServiceDefComponent } from './service-def/service-def.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { DynamicFormModule } from 'src/app/components/dynamic-form/dynamic-form.module';
import { ErrorModule } from 'src/app/components/error/error.module';
import { QuestionnaireSummaryModule } from 'src/app/components/questionnaire-summary/questionnaire-summary.module';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PipesModule } from 'src/app/pipes/pipes.module';

@NgModule({
  declarations: [
    ServiceDefinitionComponent,
    TenantSolutionsComponent,
    ChooseCapabilityComponent,
    ServiceDefComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ServiceDefinitionRoutingModule,
    IconsModule,
    NgxSkeletonLoaderModule,
    PageLoaderModule,
    MatProgressSpinnerModule,
    SearchFilterModule,
    PaginatorModule,
    MatDividerModule,
    MatCardModule,
    BreadcrumbModule,
    ReactiveFormsModule,
    FormsModule,
    DynamicFormModule,
    ErrorModule,
    QuestionnaireSummaryModule,
    MatSelectModule,
    MatSlideToggleModule,
    SearchBoxModule,
    PipesModule
  ]
  
})
export class ServiceDefinitionModule { }
